import React from "react";
import BottomSheet from "src/components/app/BottomSheet";
import { cgmDetailedLogs } from "src/constants/cgm-detailed-logs";
import LearnMoreSection from "./LearnMoreSection";

interface CGMDetailedLogsBottomSheetProps {
  show: boolean;
  onClose: () => void;
  metric: string | null;
}

const CGMDetailedLogsBottomSheet: React.FC<CGMDetailedLogsBottomSheetProps> = ({
  show,
  onClose,
  metric,
}) => {
  const detailedLogs = metric ? cgmDetailedLogs[metric] : null;

  console.log(detailedLogs);

  return (
    <BottomSheet
      show={show}
      handleClose={onClose}
      title={detailedLogs?.title}
      showCloseButton
    >
      <LearnMoreSection content={detailedLogs} />
    </BottomSheet>
  );
};

export default CGMDetailedLogsBottomSheet;
